import http from '@/http'
import createCrudModule from 'vuex-crud'

export default createCrudModule({
  client: http,
  resource: 'manager/schedule-assign',
  urlRoot: 'manager/schedule-assign'
})
